export const translationDe_AT_Suedtirol = {
    translation: {
        entity: {
            job: 'Funktion',
        },
        enum: {
            organizationLevel: {
                undefined: '',
                TROOP: 'Stamm',
                TROOP_other: 'Stämme',
                DIVISION: 'Landesverband',
                DIVISION_other: 'Landesverbände',
                FEDERATION: 'Bundesverband',
                UNDEFINED: 'Organisation',
            },
        },
        visibility: {
            member: {
                taxId: 'true'
            }
        },
        defaultValue: {
            member: {
                country: 'ITALY',
            }
        }
    }
}